// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import { Button } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { AppStatus } from 'components/layout/AppStatus'
import { PathNames } from 'constants/General'
import { ExternalLinks } from 'constants/links'
import { forceLogout } from 'utils/auth/utils'
import { redirectToPath } from 'utils/utils'

const AccountError = () => {
  const { t } = useTranslation()
  const { state: sentryTraceId } = useLocation()

  return (
    <AppStatus animationName="connection-error" title={t('errorMessages.errorHeading')}>
      <p className="text-body-regular text-foreground-subdued">
        {` ${t('errorMessages.weApologiseForInconvenience')}`}
        {` ${t('errorMessages.pleaseTryTo')} `}
        <Button
          variant="ghost"
          noPadding
          onClick={() => {
            redirectToPath(PathNames.DASHBOARD)
          }}
        >
          {t('errorMessages.refreshPage')}
        </Button>
        {` ${t('errorMessages.or')} `}
        <Button
          variant="ghost"
          noPadding
          onClick={() => {
            forceLogout()
          }}
        >
          {t('errorMessages.login.retry')}
        </Button>
        {`. `}
        {` ${t('errorMessages.ifTheProblemPersists')}, `}
        {` ${t('errorMessages.please').toLowerCase()} `}

        <ExternalLink href={ExternalLinks.CONTACT_SUPPORT}>
          {t('errorMessages.contactSupport')}
        </ExternalLink>
        {` ${t('errorMessages.forAssistance')}`}

        {sentryTraceId && (
          <p className="text-body-regular-small text-foreground-subdued pt-4">
            {t('errorMessages.traceId')}: {sentryTraceId}
          </p>
        )}
      </p>
    </AppStatus>
  )
}

export default AccountError
